// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_extraLoadingStyle__DRElp div{
    width:28px !important;
    height:28px !important;
}
.styles_extraLoadingStyle__DRElp{
    height:60px !important;
    width:60px !important;
    align-items:center;
}
.styles_absoluteBg__dkeQz{
    width:100%;
    height:100%;
    position:absolute;
    top:0;
    left:0;
    opacity:0.5;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/OnlineChat/ChatPageSearch/styles.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,WAAW;AACf","sourcesContent":[".extraLoadingStyle div{\n    width:28px !important;\n    height:28px !important;\n}\n.extraLoadingStyle{\n    height:60px !important;\n    width:60px !important;\n    align-items:center;\n}\n.absoluteBg{\n    width:100%;\n    height:100%;\n    position:absolute;\n    top:0;\n    left:0;\n    opacity:0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extraLoadingStyle": `styles_extraLoadingStyle__DRElp`,
	"absoluteBg": `styles_absoluteBg__dkeQz`
};
export default ___CSS_LOADER_EXPORT___;
